import axios from "axios";

export default function DocumenttemplateWildcardsService(entity) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/document-template/wildcards/" + entity,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
